<template>
  <base-view title="Integrações com soluções de anti fraude" class="mb-5 mr-4">
    <b-row v-if="loading">
      <b-col v-for="index in 4" :key="index">
        <b-card>
          <b-skeleton animation="throb" width="85%"></b-skeleton>
          <b-skeleton animation="throb" width="55%"></b-skeleton>
          <b-skeleton animation="throb" width="70%"></b-skeleton>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12">
        <b-alert show class="d-flex align-items-center">
          <div class="mr-3">
            <i class="fas fa-info-circle mr-1"></i>
            Já realizou a integração com algum solução de anti fraude? Agora
            seus pagamentos em cartão de crédito terão uma camada de segurança
            para você e seus usuários.
          </div>

          <b-btn
            size="sm"
            variant="primary"
            @click="$router.push({ name: 'lojista-app-anti-fraud-pedidos' })"
          >
            <i class="fas fa-shipping-fast mr-1"></i> Acompanhar pedidos
          </b-btn>
        </b-alert>
      </b-col>
      <b-col
        cols="12"
        sm="12"
        md="4"
        lg="4"
        xl="4"
        v-for="antiFraud in antiFrauds"
        :key="antiFraud.id"
      >
        <AntiFraudCard
          :anti-fraud="antiFraud"
          :loading="cardLoading[antiFraud.id]"
          @authorize="handleAuthorization(antiFraud)"
          @enable="enable(antiFraud)"
          @disable="disable(antiFraud)"
          @activate="activate(antiFraud)"
          @refresh="getAntiFrauds"
        />
      </b-col>
    </b-row>

    <component
      ref="antiFraudAuthModal"
      :is="antiFraudAuthModal"
      :anti-fraud="currentSelectedAntiFraud"
      :loading="loading"
      @refresh="getAntiFrauds"
    />
  </base-view>
</template>

<script>
import { mapState } from 'vuex';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';

import AntiFraudCard from './_components/AntiFraudCard.vue';
import EmBreveBadge from '@/components/Badge/EmBreveBadge.vue';
import IntegrationTypes from 'Enums/Integration/IntegrationTypes';
import AntiFraudMapFolder from './_components/map-folder';

export default {
  name: 'AntiFraudIndex',
  computed: {
    ...mapState(['dadosUsuario']),
    antiFraudAuthModal() {
      if (!this.currentSelectedAntiFraud || !this.currentSelectedAntiFraud.type)
        return;

      const folder = AntiFraudMapFolder[this.currentSelectedAntiFraud.type];

      return () => import(`./_components/${folder}/CredentialsModal.vue`);
    },
  },
  data() {
    return {
      loading: false,
      currentSelectedAntiFraud: null,
      cardLoading: {},
      antiFrauds: [],
      loginPasswordIntegrations: [IntegrationTypes.CLEAR_SALE],
      oauthIntegrations: [],
    };
  },
  mounted() {
    this.getAntiFrauds();
  },
  methods: {
    async getAntiFrauds() {
      this.loading = true;

      const { data } = await shopkeeperAppApi.get(
        `/integration/anti-fraud/${this.dadosUsuario.id}/integrations`
      );

      this.loading = false;

      this.antiFrauds = data.data || [];
    },
    async enable(antiFraud) {
      this.$set(this.cardLoading, antiFraud.id, true);

      try {
        await shopkeeperAppApi.get(
          `/integration/enable?integrationType=${antiFraud.type}&construpUserId=${this.dadosUsuario.id}`
        );

        this.getAntiFrauds();
      } finally {
        this.$set(this.cardLoading, antiFraud.id, false);
      }
    },
    async disable(antiFraud) {
      this.$set(this.cardLoading, antiFraud.id, true);

      try {
        await shopkeeperAppApi.get(
          `/integration/disable?integrationType=${antiFraud.type}&construpUserId=${this.dadosUsuario.id}`
        );

        this.getAntiFrauds();
      } finally {
        this.$set(this.cardLoading, antiFraud.id, false);
      }
    },
    async activate(antiFraud) {
      this.$set(this.cardLoading, antiFraud.id, true);

      try {
        await shopkeeperAppApi.get(
          `/integration/activate?integrationType=${antiFraud.type}&construpUserId=${this.dadosUsuario.id}`
        );

        this.getAntiFrauds();
      } finally {
        this.$set(this.cardLoading, antiFraud.id, false);
      }
    },
    handleAuthorization(antiFraud) {
      if (this.loginPasswordIntegrations.includes(antiFraud.type)) {
        this.currentSelectedAntiFraud = antiFraud;
        // Timeout para aguardar a renderização do modal
        // Horrível, feio, infelizmente necessário
        setTimeout(() => {
          this.$refs.antiFraudAuthModal.open();
        }, 500);
        return;
      }

      // TODO: Implementar login OAuth para integrações antifraude quando precisar
    },
  },
  components: {
    AntiFraudCard,
    EmBreveBadge,
  },
};
</script>
